<template>
  <activity-edit-main ref="createRef"></activity-edit-main>
</template>

<script>
import ActivityEditMain from './components/activity-edit-main'
export default {
  name: 'CreateActivity',
  components: {
    ActivityEditMain
  }
}
</script>

<style lang="stylus" scoped>

</style>
